import IconButton from '@material-ui/core/IconButton';
import * as React from 'react';
import { SidebarContext } from './SidebarContext';

interface ISidebarIconProps {}

let SidebarIcon: React.FunctionComponent<ISidebarIconProps> = ({ children }) => {
  const { toggle } = React.useContext(SidebarContext);

  return children ? (
    <IconButton aria-label="open drawer" color="inherit" onClick={toggle}>
      {children}
    </IconButton>
  ) : null;
};

SidebarIcon = React.memo(SidebarIcon);
export { SidebarIcon };
